import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validateur personnalisé pour empêcher les chaînes contenant uniquement des espaces
 */
export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value && typeof control.value === 'string') {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }
  return null;
}

/**
 * Validateur combiné pour les champs obligatoires sans espaces
 */
export function requiredNoWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  // D'abord vérifier si le champ est requis
  if (!control.value || control.value.trim().length === 0) {
    return { required: true };
  }
  
  // Ensuite vérifier qu'il n'y a pas que des espaces
  return noWhitespaceValidator(control);
}

/**
 * Validateur pour la longueur minimale sans espaces
 */
export function minLengthNoWhitespaceValidator(minLength: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // La validation required s'en occupe
    }
    
    const trimmedValue = control.value.toString().trim();
    if (trimmedValue.length === 0) {
      return { whitespace: true };
    }
    
    if (trimmedValue.length < minLength) {
      return { minlength: { requiredLength: minLength, actualLength: trimmedValue.length } };
    }
    
    return null;
  };
}

